import { Grid, Paper, Typography, Button, Stack, Chip } from "@mui/material"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
// Icon
import DeleteIcon from '@mui/icons-material/Delete'
import BarChartIcon from '@mui/icons-material/BarChart'
import { classeSocialKeyToLabel } from "../../../detalhes-do-projeto/filtros/classe-social"

export const RecorteClasseSocialFilterPreview = () => {
    // State
    const { createRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)

    // Hook
    const { removeCreateRecorteFormFiltros } = useRecortesExtracaoService()

    const hasClasseSocial = createRecorteExtracaoForm.fields.Filtros?.classeSocial &&
        createRecorteExtracaoForm.fields.Filtros.classeSocial.length > 0;

    const handleRemoveFilter = () => {
        removeCreateRecorteFormFiltros({ filtro: 'classeSocial' });
    };

    if (!hasClasseSocial) {
        return null;
    }

    return (
        <Grid item container xs={6} spacing={2} mb={2}>
            <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                <Grid item xs={12} container justifyContent={'space-between'} alignItems="center" my={1}>
                    <Grid item>
                        <Typography
                            variant="body1"
                            color="primary"
                            fontWeight="bold"
                            textTransform="uppercase"
                            mr={2}
                        >
                            Classe Social
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Button
                            variant="outlined"
                            startIcon={<DeleteIcon />}
                            onClick={handleRemoveFilter}
                        >
                            Remover filtro
                        </Button>
                    </Grid>
                </Grid>

                {createRecorteExtracaoForm.fields.Filtros &&
                    createRecorteExtracaoForm.fields.Filtros.classeSocial && (
                        <Grid item xs={12}>
                            <Stack
                                direction="row"
                                flexWrap="wrap"
                            >
                                {createRecorteExtracaoForm.fields.Filtros.classeSocial.map((classeSocial, i) => (
                                    <Chip
                                        key={i}
                                        icon={<BarChartIcon />}
                                        label={classeSocialKeyToLabel(classeSocial).toUpperCase()}
                                        sx={{
                                            m: 0.5
                                        }}
                                    />
                                ))}
                            </Stack>
                        </Grid>
                    )}
            </Paper>
        </Grid>
    )
}